export const translations = {
  tr: {
    nav: {
      products: "Koleksiyon",
      catalog: "Katalog",
      values: "Avantajlar",
      b2b: "Toptan",
      story: "Hikayemiz",
      order: "Hemen Sipariş Ver",
    },
    hero: {
      overline: "VOLPAR — Premium PVC Dolap Sistemleri",
      lines: ["Kombinizi Saklayın,", "Estetiği", "Ortaya Çıkarın."],
      sub: "Modern yaşam alanları ve inşaat projeleri için estetik, dayanıklı ve paslanmaz PVC dolap çözümleri.",
      ctaPrimary: "Hemen Sipariş Ver",
      ctaSecondary: "Toptan Fiyat Al",
      chips: ["Paslanmaz", "Kendin-Kur", "Özel Ölçü"],
      scroll: "Keşfetmek için kaydırın",
    },
    marquee: [
      "Ahşap Dokulu PVC",
      "Paslanmaz Yapı",
      "%100 Geri Dönüştürülebilir",
      "Kendin-Kur Montaj",
      "Özel Ölçü Sistemi",
      "120 Gün Vade",
    ],
    values: {
      chapter: "Bölüm 01",
      title: "Neden VLP Dolap?",
      sub: "Bir dolaptan fazlası: tesisatı gizleyen, mekâna değer katan mühendislik.",
      items: [
        {
          title: "%100 Geri Dönüştürülebilir",
          desc: "Çevre dostu PVC gövde; sürdürülebilir üretim anlayışıyla, doğaya borç bırakmadan üretilir.",
        },
        {
          title: "Paslanmaz & Isı Yalıtımlı",
          desc: "Nem ve buhara karşı tam direnç. Kombi ısısına dayanıklı, yıllarca ilk günkü formunda.",
        },
        {
          title: "Hızlı Kendin-Kur Montaj",
          desc: "Demonte flat-pack yapısıyla dakikalar içinde, ustaya ihtiyaç duymadan kurulum.",
        },
        {
          title: "Özel Ölçü Sistemi",
          desc: "Standart ölçülerin ötesinde; kombinize ve alanınıza milimetrik uyum sağlayan özel üretim.",
        },
      ],
    },
    products: {
      chapter: "Bölüm 02",
      title: "Koleksiyon",
      sub: "Ahşap dokulu ve mat beyaz modeller. Tüm fiyatlar KDV dahil başlangıç fiyatıdır.",
      from: "'den itibaren",
      addToCart: "Sepete Ekle",
      added: "Sepete eklendi",
      bestseller: "Çok Satan",
      dimsLabel: "Ölçüler",
    },
    catalog: {
      overline: "Katalog",
      title: "Tüm Ürünlerimiz",
      sub: "Ahşap ve beyaz serileriyle tüm PVC dolap modellerimiz. Seriye ve ölçüye göre filtreleyin, size uygun modeli kolayca bulun.",
      filterFinish: "Seri",
      filterSize: "Ölçü",
      sortLabel: "Sıralama",
      all: "Tümü",
      finishes: { wood: "Ahşap Seri", white: "Beyaz Seri" },
      sortFeatured: "Önerilen",
      sortPriceAsc: "Fiyat: Artan",
      sortPriceDesc: "Fiyat: Azalan",
      results: "ürün listeleniyor",
      noResults: "Bu filtrelere uygun ürün bulunamadı.",
      customNote: "Özel ölçü üretimi yapılmaktadır",
    },
    variations: {
      chooseSize: "Ölçü Seçin",
      selected: "Seçili",
      viewDetails: "İncele",
      inCartNote: "Seçilen ölçü sepetinize eklenecektir.",
    },
    adminContact: {
      tab: "İletişim",
      sub: "İletişim kanallarını ekleyin, düzenleyin veya silin — değişiklikler anında siteye yansır.",
      add: "Kanal Ekle",
      type: "Tür",
      labelTr: "Etiket (TR)",
      labelEn: "Etiket (EN)",
      value: "Değer",
      types: {
        phone: "Telefon",
        email: "E-posta",
        whatsapp: "WhatsApp",
        address: "Adres",
        instagram: "Instagram",
        tiktok: "TikTok",
        link: "Bağlantı",
      },
      valueHints: {
        phone: "+90 5xx xxx xx xx",
        email: "ornek@site.com",
        whatsapp: "905309304939 (başında + veya boşluk olmadan)",
        address: "Açık adres",
        instagram: "kullanıcı adı (@ olmadan)",
        tiktok: "kullanıcı adı (@ olmadan)",
        link: "https://...",
      },
      edit: "Düzenle",
      save: "Kaydet",
      cancel: "Vazgeç",
      delete: "Sil",
      added: "Kanal eklendi ve yayında!",
      updated: "Kanal güncellendi.",
      deleted: "Kanal silindi.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
      empty: "Henüz iletişim kanalı yok.",
    },
    strip: {
      chapter: "Bölüm 02",
      title: "Koleksiyonu Keşfedin",
      text: "60 × 30'dan 190 × 60'a altı standart ölçü, ahşap ve beyaz seri — tüm modellerimiz katalog sayfamızda sizi bekliyor.",
      cta: "Tüm Ürünlerimiz",
    },
    b2b: {
      chapter: "Bölüm 03",
      overline: "İnşaat Firmaları & Müteahhitler",
      title: "Toptan Alım Avantajları",
      sub: "Projeleriniz için ölçeklenebilir üretim, kurumsal ödeme koşulları ve markanıza özel çözümler.",
      items: [
        {
          title: "Demonte Flat-Pack Tasarım",
          desc: "Nakliye ve depolama maliyetlerinizi düşüren, sahada hızlı kurulan demonte yapı.",
        },
        {
          title: "Özel Logo Üretimi",
          desc: "Firma logonuzla üretim; projelerinizde markanızı öne çıkarın.",
        },
        {
          title: "120 Gün Vade",
          desc: "Kurumsal projelere özel, nakit akışınızı rahatlatan esnek ödeme planı.",
        },
      ],
      form: {
        title: "Toptan Teklif Alın",
        sub: "Formu doldurun, 24 saat içinde size özel fiyat teklifinizi iletelim.",
        name: "Ad Soyad",
        company: "Firma Adı",
        phone: "Telefon",
        quantity: "Proje Adedi",
        note: "Notunuz (opsiyonel)",
        submit: "Teklif Talebi Gönder",
        sending: "Gönderiliyor...",
        success: "Talebiniz alındı! En kısa sürede size dönüş yapacağız.",
        error: "Bir hata oluştu. Lütfen tekrar deneyin.",
      },
    },
    story: {
      chapter: "Bölüm 04",
      overline: "Hikayemiz",
      title: "Kadın Girişimciliğiyle Büyüyen Bir Atölye",
      p1: "VLP Dolap, bir kadın girişiminin vizyonuyla doğdu: evlerin en görünmez köşelerini bile estetikle buluşturmak. Her dolap, atölyemizde aynı özen ve esnaf dürüstlüğüyle üretilir.",
      p2: "Sözümüz basit: söylediğimiz günde teslim, söylediğimiz kalitede üretim. Güvenilir esnaf anlayışını sürdürülebilir üretimle birleştiriyoruz.",
      badge: "Güvenilir Esnaf",
      stats: [
        { value: "%100", label: "Geri Dönüştürülebilir Malzeme" },
        { value: "81 İl", label: "Türkiye Geneli Teslimat" },
      ],
    },
    testimonials: {
      chapter: "Bölüm 05",
      title: "Müşterilerimiz Ne Diyor?",
      score: "4.9/5",
      scoreLabel: "200+ Mutlu Müşteri",
      featured: {
        quote:
          "300 dairelik projemizde tüm kombi dolaplarını VLP'den aldık. Demonte paketler sayesinde sahada montaj inanılmaz hızlıydı; 120 gün vade de nakit akışımızı tamamen rahatlattı.",
        name: "Murat K.",
        role: "Proje Müdürü — Müteahhit Firma",
      },
      items: [
        {
          quote:
            "Kombimiz yıllardır banyonun göbeğinde duruyordu. Ceviz dokulu dolap sanki hep oradaymış gibi; eve gelen herkes dolabı soruyor.",
          name: "Elif S.",
          role: "Ev Sahibi — İstanbul",
        },
        {
          quote:
            "Kendin-kur paketini 20 dakikada monte ettim, ustaya gerek kalmadı. Ölçüler birebir uydu, malzeme kalitesi beklediğimden çok daha iyi.",
          name: "Hakan D.",
          role: "Ev Sahibi — Ankara",
        },
        {
          quote:
            "Özel logolu üretimle projelerimizde kendi markamızı öne çıkardık. İletişim ve teslimat her zaman söz verdikleri günde.",
          name: "Ayşe T.",
          role: "Satınalma Sorumlusu — İnşaat",
        },
        {
          quote:
            "Mutfaktaki tesisatı gizleyen dolap için özel ölçü istedim, milimetrik uydu. WhatsApp üzerinden sipariş süreci de çok pratikti.",
          name: "Zeynep A.",
          role: "Ev Sahibi — İzmir",
        },
      ],
    },
    footer: {
      contact: "İletişim",
      tagline: "Kombinizi saklayın, estetiği ortaya çıkarın.",
      rights: "Tüm hakları saklıdır.",
      nav: "Sayfa",
      social: "Sosyal Medya",
      address: "Pınarbaşı Cad. Kemalpaşa mah. 7087 sk No26/C İzmir/Bornova, Türkiye",
      location: "İzmir / Türkiye",
    },
    cart: {
      title: "Sepetiniz",
      empty: "Sepetiniz henüz boş.",
      emptyCta: "Koleksiyona Göz Atın",
      total: "Toplam",
      orderWhatsapp: "WhatsApp ile Sipariş Ver",
      note: "Ödeme ve teslimat detayları WhatsApp üzerinden netleştirilir.",
      clear: "Sepeti Temizle",
      each: "adet",
    },
    auth: {
      login: "Giriş Yap",
      register: "Kayıt Ol",
      loginTitle: "Hesabınıza giriş yapın",
      registerTitle: "Hesap oluşturun",
      name: "Ad Soyad",
      email: "E-posta",
      password: "Şifre",
      passwordMin: "Şifre en az 8 karakter olmalıdır.",
      loginCta: "Giriş Yap",
      registerCta: "Kayıt Ol",
      submitting: "Lütfen bekleyin...",
      loginSuccess: "Hoş geldiniz!",
      registerSuccess: "Hesabınız oluşturuldu!",
      logout: "Çıkış Yap",
      backHome: "Ana Sayfa",
      accountTitle: "Hesabım",
      welcome: "Hoş geldiniz",
      roleLabel: "Hesap Türü",
      memberSince: "Üyelik Tarihi",
      roles: { admin: "Yönetici", customer: "Müşteri" },
      ordersNote:
        "Siparişleriniz WhatsApp üzerinden yürütülmektedir. Sipariş durumunuzla ilgili bize WhatsApp hattımızdan yazabilirsiniz.",
      adminOverline: "Yönetici Paneli",
      adminPanel: "Teklif Talepleri",
      adminPanelSub: "B2B formu üzerinden gelen tüm toptan teklif talepleri.",
      noQuotes: "Henüz teklif talebi yok.",
      loading: "Yükleniyor...",
      cols: { date: "Tarih", name: "Ad Soyad", company: "Firma", phone: "Telefon", quantity: "Adet", note: "Not" },
      errors: {
        invalidCreds: "E-posta veya şifre hatalı.",
        emailExists: "Bu e-posta ile bir hesap zaten var.",
        locked: "Çok fazla başarısız deneme. Lütfen 15 dakika sonra tekrar deneyin.",
        generic: "Bir hata oluştu. Lütfen tekrar deneyin.",
      },
      forgotLink: "Şifremi Unuttum",
      forgotTitle: "Şifrenizi sıfırlayın",
      forgotSub: "E-posta adresinizi girin, size sıfırlama bağlantısı gönderelim.",
      forgotCta: "Sıfırlama Bağlantısı Gönder",
      forgotSentMsg:
        "Bu e-posta ile bir hesap varsa, sıfırlama bağlantısı gönderildi. Lütfen gelen kutunuzu kontrol edin.",
      backToLogin: "Girişe Dön",
      resetTitle: "Yeni şifrenizi belirleyin",
      newPassword: "Yeni Şifre",
      confirmPassword: "Yeni Şifre (Tekrar)",
      resetCta: "Şifreyi Güncelle",
      resetSuccess: "Şifreniz güncellendi! Artık giriş yapabilirsiniz.",
      resetInvalid: "Bağlantı geçersiz veya süresi dolmuş. Lütfen yeni bir bağlantı isteyin.",
      passwordMismatch: "Şifreler eşleşmiyor.",
    },
    reviews: {
      writeReview: "Değerlendirme Yaz",
      formTitle: "Deneyiminizi Paylaşın",
      formSub: "Yorumunuz, yönetici onayının ardından sitede yayınlanacaktır.",
      name: "Adınız",
      rating: "Puanınız",
      comment: "Yorumunuz",
      commentPlaceholder: "Ürün ve hizmet deneyiminizi anlatın...",
      photo: "Fotoğraf (opsiyonel)",
      photoHint: "JPG, PNG veya WebP — en fazla 5 MB",
      choosePhoto: "Fotoğraf Seç",
      submit: "Yorumu Gönder",
      sending: "Gönderiliyor...",
      success: "Teşekkürler! Yorumunuz alındı; onaylandıktan sonra yayınlanacak.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
      quotesTab: "Teklif Talepleri",
      reviewsTab: "Yorumlar",
      pending: "Beklemede",
      approved: "Yayında",
      approve: "Onayla",
      delete: "Sil",
      noReviews: "Henüz yorum yok.",
      noPending: "Bekleyen yorum yok.",
      approvedToast: "Yorum onaylandı ve yayınlandı.",
      deletedToast: "Yorum silindi.",
      adminReviewsSub: "Müşteri yorumlarını onaylayın veya silin. Yalnızca onaylanan yorumlar sitede görünür.",
      emptyPublic: "Henüz müşteri yorumu yok. İlk yorumu siz yazın!",
      countLabel: "Değerlendirme",
    },
    adminSettings: {
      tab: "Ayarlar",
      sub: "Katalog filtreleri ve ürün formu buradan otomatik güncellenir.",
      seriesTitle: "Seriler",
      dimsTitle: "Standart Ölçüler",
      labelTr: "Etiket (TR)",
      labelEn: "Etiket (EN)",
      addSeries: "Seri Ekle",
      addDims: "Ölçü Ekle",
      dimsPlaceholder: "ör. 120 × 60 × 38 cm",
      edit: "Düzenle",
      save: "Kaydet",
      cancel: "Vazgeç",
      delete: "Sil",
      added: "Eklendi ve anında yayında!",
      updated: "Güncellendi.",
      deleted: "Silindi.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
      emptySeries: "Henüz seri yok.",
      emptyDims: "Henüz ölçü yok.",
    },
    adminHome: {
      tab: "Ana Sayfa",
      sub: "Ana sayfa metinlerini ve görsellerini düzenleyin — kaydettiğinizde anında yayına alınır.",
      groups: {
        hero: "Hero (Giriş) Bölümü",
        strip: "Koleksiyon Şeridi",
        b2b: "Toptan (B2B) Bölümü",
        story: "Hikaye Bölümü",
        testimonials: "Yorumlar Bölümü",
      },
      labels: {
        hero_overline: "Üst başlık",
        hero_line1: "Başlık 1. satır",
        hero_line2: "Başlık 2. satır",
        hero_line3: "Başlık 3. satır",
        hero_sub: "Alt başlık",
        strip_title: "Şerit başlığı",
        strip_text: "Şerit metni",
        b2b_title: "Toptan başlığı",
        b2b_sub: "Toptan alt metni",
        story_title: "Hikaye başlığı",
        story_p1: "1. paragraf",
        story_p2: "2. paragraf",
        testimonials_title: "Bölüm başlığı",
        testimonials_score: "Puan (ör. 4.9/5)",
        testimonials_scoreLabel: "Puan etiketi",
      },
      heroImage: "Hero Görseli",
      storyImage: "Hikaye Görseli",
      uploadImage: "Görsel Yükle",
      imageHint: "JPG, PNG veya WebP — en fazla 5 MB",
      save: "Kaydet ve Yayınla",
      saving: "Kaydediliyor...",
      saved: "Ana sayfa içeriği güncellendi ve yayında!",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
    },
    adminProducts: {
      tab: "Ürünler",
      sub: "Ürün ekleyin, düzenleyin veya silin — değişiklikler anında yayına alınır.",
      add: "Yeni Ürün Ekle",
      edit: "Düzenle",
      delete: "Sil",
      newTitle: "Yeni Ürün",
      editTitle: "Ürünü Düzenle",
      nameTr: "Ürün Adı (TR)",
      nameEn: "Ürün Adı (EN)",
      series: "Seri",
      dims: "Ölçüler",
      dimsPlaceholder: "ör. 110 × 60 × 38 cm",
      price: "Fiyat (₺)",
      descTr: "Açıklama (TR)",
      descEn: "Açıklama (EN)",
      photoLabel: "Ürün Fotoğrafı",
      videoLabel: "Ürün Videosu (opsiyonel)",
      imageUrlLabel: "veya Fotoğraf URL'si",
      photoHint: "JPG, PNG veya WebP — en fazla 5 MB",
      videoHint: "MP4 veya WebM — en fazla 60 MB",
      bestseller: "Çok Satan olarak işaretle",
      save: "Kaydet ve Yayınla",
      saving: "Kaydediliyor...",
      saved: "Ürün kaydedildi ve anında yayında!",
      deleted: "Ürün silindi.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
      noProducts: "Henüz ürün yok.",
      hasVideo: "Video var",
      currentPhoto: "Mevcut fotoğraf",
      availableDims: "Seçilebilir Ölçüler (çoklu seçim)",
      availableDimsHint: "Müşteriler bu ürün için işaretlediğiniz ölçüler arasından seçim yapar.",
    },
    whatsapp: {
      float: "WhatsApp ile Sipariş",
      cartMsg: "Merhaba! VLP Dolap üzerinden sipariş vermek istiyorum:",
      total: "Toplam",
    },
  },
  en: {
    nav: {
      products: "Collection",
      catalog: "Catalog",
      values: "Advantages",
      b2b: "Wholesale",
      story: "Our Story",
      order: "Order Now",
    },
    hero: {
      overline: "VOLPAR — Premium PVC Cabinet Systems",
      lines: ["Hide the Boiler,", "Reveal the", "Aesthetic."],
      sub: "Aesthetic, durable, and rustproof PVC cabinet solutions for modern living spaces and construction projects.",
      ctaPrimary: "Order Now",
      ctaSecondary: "Get B2B Quote",
      chips: ["Rustproof", "DIY Assembly", "Custom Sizing"],
      scroll: "Scroll to explore",
    },
    marquee: [
      "Wood-Textured PVC",
      "Rustproof Build",
      "100% Recyclable",
      "DIY Assembly",
      "Custom Sizing System",
      "120-Day Terms",
    ],
    values: {
      chapter: "Chapter 01",
      title: "Why VLP Dolap?",
      sub: "More than a cabinet: engineering that hides plumbing and elevates the room.",
      items: [
        {
          title: "100% Recyclable Eco-Friendly",
          desc: "Eco-conscious PVC body, produced with a sustainable mindset that leaves no debt to nature.",
        },
        {
          title: "Rustproof & Heat Insulated",
          desc: "Full resistance to moisture and steam. Withstands boiler heat, keeping its form for years.",
        },
        {
          title: "Fast DIY Assembly",
          desc: "Flat-pack structure assembles in minutes — no tradesman required.",
        },
        {
          title: "Custom Sizing System",
          desc: "Beyond standard dimensions: millimetric custom production that fits your boiler and your space.",
        },
      ],
    },
    products: {
      chapter: "Chapter 02",
      title: "The Collection",
      sub: "Wood-textured and matte white models. All prices are VAT-included starting prices.",
      from: "from",
      addToCart: "Add to Cart",
      added: "Added to cart",
      bestseller: "Bestseller",
      dimsLabel: "Dimensions",
    },
    catalog: {
      overline: "Catalog",
      title: "All Our Products",
      sub: "Every PVC cabinet model in the Wood and White series. Filter by series and dimensions to find the model that fits you.",
      filterFinish: "Series",
      filterSize: "Dimensions",
      sortLabel: "Sort",
      all: "All",
      finishes: { wood: "Wood Series", white: "White Series" },
      sortFeatured: "Featured",
      sortPriceAsc: "Price: Low to High",
      sortPriceDesc: "Price: High to Low",
      results: "products listed",
      noResults: "No products match these filters.",
      customNote: "Custom sizes available for all items",
    },
    variations: {
      chooseSize: "Choose Size",
      selected: "Selected",
      viewDetails: "View Details",
      inCartNote: "The selected size will be added to your cart.",
    },
    adminContact: {
      tab: "Contact",
      sub: "Add, edit or delete contact channels — changes reflect on the site instantly.",
      add: "Add Channel",
      type: "Type",
      labelTr: "Label (TR)",
      labelEn: "Label (EN)",
      value: "Value",
      types: {
        phone: "Phone",
        email: "Email",
        whatsapp: "WhatsApp",
        address: "Address",
        instagram: "Instagram",
        tiktok: "TikTok",
        link: "Link",
      },
      valueHints: {
        phone: "+90 5xx xxx xx xx",
        email: "example@site.com",
        whatsapp: "905309304939 (no + or spaces)",
        address: "Full address",
        instagram: "username (no @)",
        tiktok: "username (no @)",
        link: "https://...",
      },
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      added: "Channel added and live!",
      updated: "Channel updated.",
      deleted: "Channel deleted.",
      error: "Something went wrong. Please try again.",
      empty: "No contact channels yet.",
    },
    strip: {
      chapter: "Chapter 02",
      title: "Explore the Collection",
      text: "Six standard dimensions from 60 × 30 to 190 × 60, in wood and white series — every model awaits you in our catalog.",
      cta: "View All Products",
    },
    b2b: {
      chapter: "Chapter 03",
      overline: "Contractors & Construction Firms",
      title: "Wholesale Advantages",
      sub: "Scalable production for your projects, corporate payment terms, and solutions tailored to your brand.",
      items: [
        {
          title: "Flat-Pack Demountable Design",
          desc: "Demountable structure that cuts shipping and storage costs and installs fast on site.",
        },
        {
          title: "Custom Logo Production",
          desc: "Manufactured with your company logo — put your brand forward in every project.",
        },
        {
          title: "120-Day Payment Terms",
          desc: "A flexible payment plan exclusive to corporate projects, easing your cash flow.",
        },
      ],
      form: {
        title: "Get a Wholesale Quote",
        sub: "Fill in the form and we'll send your tailored quote within 24 hours.",
        name: "Full Name",
        company: "Company Name",
        phone: "Phone",
        quantity: "Project Quantity",
        note: "Your note (optional)",
        submit: "Request Quote",
        sending: "Sending...",
        success: "Request received! We'll get back to you shortly.",
        error: "Something went wrong. Please try again.",
      },
    },
    story: {
      chapter: "Chapter 04",
      overline: "Our Story",
      title: "A Workshop Grown by Women's Entrepreneurship",
      p1: "VLP Dolap was born from the vision of a woman entrepreneur: to bring aesthetics to even the most invisible corners of the home. Every cabinet is produced in our workshop with the same care and tradesman honesty.",
      p2: "Our promise is simple: delivered on the day we say, built to the quality we say. We combine the reliable-tradesman ethos with sustainable production.",
      badge: "Trusted Tradesman",
      stats: [
        { value: "100%", label: "Recyclable Material" },
        { value: "81 Cities", label: "Nationwide Delivery" },
      ],
    },
    testimonials: {
      chapter: "Chapter 05",
      title: "What Our Customers Say",
      score: "4.9/5",
      scoreLabel: "200+ Happy Customers",
      featured: {
        quote:
          "We sourced every boiler cabinet for our 300-unit project from VLP. The flat-pack design made on-site assembly incredibly fast, and the 120-day terms completely eased our cash flow.",
        name: "Murat K.",
        role: "Project Manager — Contractor",
      },
      items: [
        {
          quote:
            "Our boiler sat in the middle of the bathroom for years. The walnut cabinet looks like it was always meant to be there — every guest asks about it.",
          name: "Elif S.",
          role: "Homeowner — Istanbul",
        },
        {
          quote:
            "I assembled the DIY pack in 20 minutes, no tradesman needed. The dimensions fit perfectly and the material quality far exceeded my expectations.",
          name: "Hakan D.",
          role: "Homeowner — Ankara",
        },
        {
          quote:
            "Custom logo production put our own brand forward in our projects. Communication and delivery always arrive on the promised day.",
          name: "Ayşe T.",
          role: "Procurement Lead — Construction",
        },
        {
          quote:
            "I requested custom sizing for the cabinet hiding my kitchen plumbing and it fit to the millimetre. Ordering over WhatsApp was effortless.",
          name: "Zeynep A.",
          role: "Homeowner — Izmir",
        },
      ],
    },
    footer: {
      contact: "Contact",
      tagline: "Hide the boiler, reveal the aesthetic.",
      rights: "All rights reserved.",
      nav: "Page",
      social: "Social Media",
      address: "Pınarbaşı Cad. Kemalpaşa mah. 7087 sk No26/C İzmir/Bornova, Türkiye",
      location: "İzmir / Türkiye",
    },
    cart: {
      title: "Your Cart",
      empty: "Your cart is empty.",
      emptyCta: "Browse the Collection",
      total: "Total",
      orderWhatsapp: "Order via WhatsApp",
      note: "Payment and delivery details are finalized over WhatsApp.",
      clear: "Clear Cart",
      each: "pcs",
    },
    auth: {
      login: "Sign In",
      register: "Sign Up",
      loginTitle: "Sign in to your account",
      registerTitle: "Create an account",
      name: "Full Name",
      email: "Email",
      password: "Password",
      passwordMin: "Password must be at least 8 characters.",
      loginCta: "Sign In",
      registerCta: "Sign Up",
      submitting: "Please wait...",
      loginSuccess: "Welcome back!",
      registerSuccess: "Your account has been created!",
      logout: "Sign Out",
      backHome: "Home",
      accountTitle: "My Account",
      welcome: "Welcome",
      roleLabel: "Account Type",
      memberSince: "Member Since",
      roles: { admin: "Admin", customer: "Customer" },
      ordersNote:
        "Your orders are handled over WhatsApp. For order status, message us on our WhatsApp line.",
      adminOverline: "Admin Panel",
      adminPanel: "Quote Requests",
      adminPanelSub: "All wholesale quote requests received via the B2B form.",
      noQuotes: "No quote requests yet.",
      loading: "Loading...",
      cols: { date: "Date", name: "Name", company: "Company", phone: "Phone", quantity: "Qty", note: "Note" },
      errors: {
        invalidCreds: "Invalid email or password.",
        emailExists: "An account with this email already exists.",
        locked: "Too many failed attempts. Please try again in 15 minutes.",
        generic: "Something went wrong. Please try again.",
      },
      forgotLink: "Forgot Password",
      forgotTitle: "Reset your password",
      forgotSub: "Enter your email address and we'll send you a reset link.",
      forgotCta: "Send Reset Link",
      forgotSentMsg:
        "If an account exists for this email, a reset link has been sent. Please check your inbox.",
      backToLogin: "Back to Sign In",
      resetTitle: "Set your new password",
      newPassword: "New Password",
      confirmPassword: "New Password (Repeat)",
      resetCta: "Update Password",
      resetSuccess: "Your password has been updated! You can now sign in.",
      resetInvalid: "This link is invalid or has expired. Please request a new one.",
      passwordMismatch: "Passwords do not match.",
    },
    reviews: {
      writeReview: "Write a Review",
      formTitle: "Share Your Experience",
      formSub: "Your review will be published on the site after admin approval.",
      name: "Your Name",
      rating: "Your Rating",
      comment: "Your Review",
      commentPlaceholder: "Tell us about your product and service experience...",
      photo: "Photo (optional)",
      photoHint: "JPG, PNG or WebP — max 5 MB",
      choosePhoto: "Choose Photo",
      submit: "Submit Review",
      sending: "Sending...",
      success: "Thank you! Your review was received and will be published once approved.",
      error: "Something went wrong. Please try again.",
      quotesTab: "Quote Requests",
      reviewsTab: "Reviews",
      pending: "Pending",
      approved: "Published",
      approve: "Approve",
      delete: "Delete",
      noReviews: "No reviews yet.",
      noPending: "No pending reviews.",
      approvedToast: "Review approved and published.",
      deletedToast: "Review deleted.",
      adminReviewsSub: "Approve or delete customer reviews. Only approved reviews appear on the site.",
      emptyPublic: "No customer reviews yet. Be the first to write one!",
      countLabel: "reviews",
    },
    adminSettings: {
      tab: "Settings",
      sub: "Catalog filters and the product form update automatically from here.",
      seriesTitle: "Series",
      dimsTitle: "Standard Dimensions",
      labelTr: "Label (TR)",
      labelEn: "Label (EN)",
      addSeries: "Add Series",
      addDims: "Add Dimension",
      dimsPlaceholder: "e.g. 120 × 60 × 38 cm",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      added: "Added and live instantly!",
      updated: "Updated.",
      deleted: "Deleted.",
      error: "Something went wrong. Please try again.",
      emptySeries: "No series yet.",
      emptyDims: "No dimensions yet.",
    },
    adminHome: {
      tab: "Homepage",
      sub: "Edit homepage texts and images — they go live the moment you save.",
      groups: {
        hero: "Hero Section",
        strip: "Collection Strip",
        b2b: "Wholesale (B2B) Section",
        story: "Story Section",
        testimonials: "Reviews Section",
      },
      labels: {
        hero_overline: "Overline",
        hero_line1: "Headline line 1",
        hero_line2: "Headline line 2",
        hero_line3: "Headline line 3",
        hero_sub: "Subheadline",
        strip_title: "Strip title",
        strip_text: "Strip text",
        b2b_title: "Wholesale title",
        b2b_sub: "Wholesale subtext",
        story_title: "Story title",
        story_p1: "Paragraph 1",
        story_p2: "Paragraph 2",
        testimonials_title: "Section title",
        testimonials_score: "Score (e.g. 4.9/5)",
        testimonials_scoreLabel: "Score label",
      },
      heroImage: "Hero Image",
      storyImage: "Story Image",
      uploadImage: "Upload Image",
      imageHint: "JPG, PNG or WebP — max 5 MB",
      save: "Save & Publish",
      saving: "Saving...",
      saved: "Homepage content updated and live!",
      error: "Something went wrong. Please try again.",
    },
    adminProducts: {
      tab: "Products",
      sub: "Add, edit or delete products — changes go live instantly.",
      add: "Add New Product",
      edit: "Edit",
      delete: "Delete",
      newTitle: "New Product",
      editTitle: "Edit Product",
      nameTr: "Product Name (TR)",
      nameEn: "Product Name (EN)",
      series: "Series",
      dims: "Dimensions",
      dimsPlaceholder: "e.g. 110 × 60 × 38 cm",
      price: "Price (₺)",
      descTr: "Description (TR)",
      descEn: "Description (EN)",
      photoLabel: "Product Photo",
      videoLabel: "Product Video (optional)",
      imageUrlLabel: "or Photo URL",
      photoHint: "JPG, PNG or WebP — max 5 MB",
      videoHint: "MP4 or WebM — max 60 MB",
      bestseller: "Mark as Bestseller",
      save: "Save & Publish",
      saving: "Saving...",
      saved: "Product saved and live instantly!",
      deleted: "Product deleted.",
      error: "Something went wrong. Please try again.",
      noProducts: "No products yet.",
      hasVideo: "Has video",
      currentPhoto: "Current photo",
      availableDims: "Available Dimensions (multi-select)",
      availableDimsHint: "Customers choose among the dimensions you check for this product.",
    },
    whatsapp: {
      float: "Order via WhatsApp",
      cartMsg: "Hello! I'd like to order from VLP Dolap:",
      total: "Total",
    },
  },
};

export const WHATSAPP_NUMBER = "905309304939";
export const CONTACT_PHONE = "+90 530 930 49 39";
export const CONTACT_EMAIL = "volparyapi@gmail.com";
